function create_html(product,variant) {
    var images = product.images;
    var url = product.handle;
    var name = variant.title != 'Default Title' ? product.title+' '+variant.title : product.title;
    var price = '<span class="sale"><span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.price)+'" data-currency="'+shop_currency+'">'+money_format+(variant.price)+'</span></span>';
    var html = '' +
        '<tr> ' +
            '<td> ' +
            '<div class="delete"> ' +
            '<a href="#" class="add-wishlist wished in-wished" data-variant="'+variant.id+'" ><img src="//cdn.shopify.com/s/files/1/0005/5443/4617/t/2/assets/delete.png" alt=""></a> ' +
            '</div> ' +
            '<div class="product"> ' +
            '<div class="image"> ' +
            '<img src="'+images[0].src+'" alt=""> ' +
            '</div> ' +
            '<div class="name"><a href="/products/'+url+'/?variant='+variant.id+'">'+name+'</a></div> ' +
            '</div> ' +
            '</td> ' +
            '<td> ' +
            '<div class="price">'+price+'</div> ' +
            '</td> ' +
            '<td> ' +
            '<div class="status-product"> <span>In stock</span> </div> ' +
            '</td> ' +
            '<td> ' +
            '<div class="add-cart"> <a href="#" class="add-to-cart" data-variant="'+variant.id+'"> <img src="//cdn.shopify.com/s/files/1/0005/5443/4617/t/2/assets/add-cart.png" alt="">Add to Cart </a> </div> ' +
            '</td> ' +
        '</tr>';
    return html;
}
if ($('.flat-wishlist').length > 0) {
    if(customer_id != '') {
        $.ajax({
            url: 'https://farost.net/appshopify/wishlist/wishlist.php',
            type: 'GET',
            data: {
                customer_id: customer_id,
                shop: domain,
                type: 'get'
            },
            dataType: 'json'
        }).always(function (response) {
            var products = response.data;
            var wish = wishlists.split(',');
            var results = [];
            if(products.length > 0) {
                $('.table-wishlist tbody').empty();
                $.each(products, function (i, e) {
                    if (results == null) {
                        results.push(products[0]);
                    } else {
                        var isset = true;
                        $.each(results, function (j, p) {
                            if (e.id.toString() == p.id.toString()) {
                                isset = false;
                                return false;
                            }
                        });
                        if (isset) {
                            results.push(e);
                        }
                    }
                });
                products = results;
                for (var i = 0; i <= products.length; i++) {
                    var product = products[i];
                    if (typeof product !== "undefined") {
                        if (product.variants.length > 1) {
                            $.each(product.variants, function (i, e) {
                                $.each(wish, function (j, w) {
                                    if (e.id.toString() == w) {
                                        var html = create_html(product, e);
                                        $('.table-wishlist tbody').append(html);
                                    }
                                })
                            });
                        } else {
                            var html = create_html(product, product.variants[0]);
                            $('.table-wishlist tbody').append(html);
                        }
                    }
                }
            }
        });
    }
}
$(document).on('click', 'a.add-wishlist', function(e) {
    e.preventDefault();
    var $this = $(this);
    $this.find('.fa').removeClass('fa-heart-o').addClass('fa-heart');
    var variant_id = $this.attr('data-variant');
    if (customer_id == "") {
        return;
    }
    var data = {
        customer_id: customer_id,
        variant_id: variant_id,
        type: 'update',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            if (response.type == "add") {
                console.log(response);
            }
            if (response.type == "remove") {
                $this.find('.fa').removeClass('fa-heart').addClass('fa-heart-o');
            }
        }
    });
});
$(document).on('click', 'a.in-wished', function(e) {
    e.preventDefault();
    var $this = $(this);
    var variant_id = $this.attr('data-variant');
    if (customer_id == "") {
        return;
    }
    var data = {
        customer_id: customer_id,
        variant_id: variant_id,
        type: 'update',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            if (response.type == "remove") {
                $this.parents('tr').fadeOut('slow').remove();
                window.location = window.location;
            }
        }
    });
});
$(document).on('click', 'a.clear-wishlist', function(e) {
    e.preventDefault();
    var data = {
        customer_id: customer_id,
        type: 'delete-all',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            window.location = window.location;
        }
    });
});